import { useParams } from 'react-router-dom';
import DataSet from './DataSet';

export function DataSetPage() {
  const params = useParams();

  return <DataSet id={params.dataSetId} />;
}
